import { NavGroup } from "./nav-group";
import { findNav, navGroupLabels, primaryNav } from "@/constants/nav.constants";
import { useVisibleNav } from "@/features/navigation/hooks/use-visible-nav";
import { m } from "@/paraglide/messages.js";

/** The main navigation: the "Main menu" block with the person's own, then what there is to find. */
export function NavMain() {
  const visiblePrimaryNav = useVisibleNav(primaryNav);
  const visibleFindNav = useVisibleNav(findNav);

  return (
    <>
      <NavGroup label={navGroupLabels.primary ?? m.layout_nav_group_primary()} entries={visiblePrimaryNav} />
      <NavGroup label={navGroupLabels.find} entries={visibleFindNav} />
    </>
  );
}
